import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSToolbarExpandedState } from '../toolbar/index.esm.js';
import styles from '../../styles/uitk-egds-toolbar.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { analyticsTracker } from '../../utils/analytics-tracker/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSToolbarButton = props => {
  const {
    disabled,
    onClick,
    buttonRef,
    onClickAnalytics,
    buttonId,
    expandedState,
    containerId,
    children
  } = props;
  const analytics = onClickAnalytics && {
    localAnalyticsId: 'Close',
    ...onClickAnalytics
  };
  let iconContent;
  let buttonLabel;
  // Map through the children and place the ones we want in specific places
  React.Children.forEach(children, child => {
    if (!child) {
      return;
    }
    if (child?.type?.displayName?.match(/(EGDS|Uitk)Icon/) && !iconContent) {
      iconContent = child;
    } else if (typeof child === 'string' && !buttonLabel) {
      buttonLabel = child;
    }
  });
  const baseClass = 'uitk-toolbar-button';
  const contentClass = `${baseClass}-content`;
  const wrapperClassName = getClassNameList(baseClass, !buttonLabel && `${baseClass}-icon-only`, buttonLabel && `${baseClass}-has-label`);
  const contentClassNames = getClassNameList(contentClass, !buttonLabel && `${contentClass}-icon-only`, buttonLabel && `${contentClass}-has-label`);
  return jsx("button", {
    "aria-controls": containerId,
    "aria-expanded": expandedState ? expandedState === EGDSToolbarExpandedState.EXPANDED : undefined,
    className: wrapperClassName,
    "data-testid": "egds-toolbar-button",
    disabled: disabled,
    onClick: onClick,
    onClickCapture: analyticsTracker.bind(undefined, analytics),
    id: buttonId,
    ref: buttonRef,
    type: "button",
    children: jsxs("span", {
      className: contentClassNames,
      children: [iconContent, buttonLabel && jsx("span", {
        className: getClassNameList(`${contentClass}-label`),
        children: buttonLabel
      })]
    })
  });
};
EGDSToolbarButton.displayName = 'EGDSToolbarButton';
export { EGDSToolbarButton };